/** @type {Array<{name: string, color: string, members: string[], contains?: string[]}>} */
const COLOR_GROUPS = [
  { name: 'Zwart',      color: '#1c1c1c',  members: ['Zwart', 'Mat Zwart', 'Nacht Zwart', 'Antraciet', 'Carbon', 'Zwart Mat', 'Zwart 2', 'Zwart mix', 'Zwart/blauw', 'Zwart/geel', 'Zwart/goud', 'Zwart/goud 2', 'Zwart/grijs', 'Zwart/groen', 'Zwart/koraal', 'Zwart/lichtblauw', 'Zwart/lichtroze', 'Zwart/oranje', 'Zwart/rood', 'Zwart/rood 2', 'Zwart/roze', 'Zwart/wit', 'Zwart/zilver', 'Zwart/zilver 2', 'Black/White', 'Carbon Fiber', 'Lava'] },
  { name: 'Grafiet',    color: '#53575e',  members: ['Grafiet'] },
  { name: 'Wit',        color: '#f2f2f2',  members: ['Wit', 'Ivoor', 'Crème', 'Off-White', 'Parel', 'Wit/Crème', 'Wit/donkerblauw', 'Wit/goud', 'Wit/rood', 'Wit/roze', 'Wit/zilver', 'Wit/zwart', 'Cream', 'Creme'] },
  { name: 'Grijs',      color: '#8a8a8a',  members: ['Grijs', 'Lichtgrijs', 'Donkergrijs', 'Zilvergrijs', 'Titaniumgrijs', 'Space Grey', 'Space Gray', 'Grijs Mix', 'Grijs/geel', 'Grijs/zwart', 'Titanium', 'Titanium grijs', 'Titanium/grijs', 'Titanium/oranje', 'Titanium/zwart', 'Donkergrijs/oranje'] },
  { name: 'Zilver',     color: '#c0c0c0',  members: ['Zilver', 'Chrome', 'Platina', 'Zilver/Grijs', 'Geborsteld Zilver', 'Zilver 2', 'Zilver/goud', 'Zilver/zwart'] },
  { name: 'Goud',       color: '#c8a84b',  members: ['Goud', 'Geelgoud', 'Goud Mat', 'Goud/Zwart'] },
  { name: 'Rosé Goud',  color: '#e8a898',  members: ['Rosé Goud', 'Rosegoud', 'Roségoud', 'Rose Gold', 'Rosé', 'Rosegold', 'Roze Goud', 'Rosé goud'] },
  { name: 'Champagne Goud', color: '#d4b878', members: ['Champagne Goud', 'Champagnegoud', 'Champagne Gold'] },
  { name: 'Blauw',      color: '#2563eb',  members: ['Blauw', 'Blauw Mix', 'Lichtblauw', 'Donkerblauw', 'Navy', 'Marineblauw', 'Kobaltblauw', 'Koningsblauw', 'IJsblauw', 'Middernachtblauw', 'Indigo Blauw', 'Grijsblauw', 'Groenblauw', 'Aqua', 'Aqua/blauw', 'Azure blauw', 'Blauw/roze', 'Blauw/wit', 'Blauw/zwart', 'Blue sea green', 'Donkerblauw mix', 'Donkerblauw/beige', 'Donkerblauw/zwart', 'Indigo', 'Licht cyaan', 'Lichtblauw/wit', 'Lichtblauw/zwart', 'Mist blauw', 'Royaal blauw', 'Turquoise', 'Zandblauw'] },
  { name: 'Rood',       color: '#dc2626',  members: ['Rood', 'Donkerrood', 'Bordeaux', 'Wijnrood', 'Robijn', 'Scarlet', 'Rood Mix', 'Knalrood', 'Rood/zwart', 'Dark cherry', 'True berry', 'Rosé-rood', 'Rosé-rood'] },
  { name: 'Roze',       color: '#f472b6',  members: ['Roze', 'Lichtroze', 'Donkerroze', 'Fuchsia', 'Magenta', 'Roze Mix', 'Flamingo', 'Oud Roze', 'Antiek Roze', 'Antiek roze', 'Knalroze', 'Knalroze/roodbruin', 'Knalroze/sterrenlicht', 'Neon pink', 'Pink Sand', 'Pink sand', 'Pink pomelo', 'Rosé pink', 'Roze/aqua', 'Zand roze', 'Mauve/lichtroze', 'Cherry magenta', 'Dragonfruit', 'Blossom', 'Bright Powder', 'Rosé pink'] },
  { name: 'Paars',      color: '#7c3aed',  members: ['Paars', 'Violet', 'Lila', 'Lavendel', 'Aubergine', 'Pruim', 'Lavendel grijs', 'Lavendel/paars', 'Lichtpaars', 'Lila/paars', 'Paars mix', 'Paars/blauw', 'Paars/groen', 'Plum'] },
  { name: 'Groen',      color: '#16a34a',  members: ['Groen', 'Lichtgroen', 'Donkergroen', 'Olijfgroen', 'Khaki', 'Mint', 'Jade', 'Groen Mix', 'Bosgroen', 'Saliegroen', 'Limoengroen', 'Legergroen', 'Dennengroen', 'Groen-blauw', 'Groen/zwart', 'Kaki', 'Legergroen/zwart', 'Lime', 'Moss green', 'Olijf', 'Rock green', 'Veld groen'] },
  { name: 'Geel',       color: '#eab308',  members: ['Geel', 'Lichtgeel', 'Citroengeel', 'Okergeel', 'Mosterd', 'Geel Mix', 'Knalgeel/zwart', 'Donkergeel/grijs'] },
  { name: 'Oranje',     color: '#f97316',  members: ['Oranje', 'Lichtoranje', 'Donkeroranje', 'Terracotta', 'Zalm', 'Perzik', 'Koraal', 'Fluoriserend', 'Oranje mix', 'Oranje/zwart', 'Kumquat'] },
  { name: 'Bruin',      color: '#92400e',  members: ['Bruin', 'Lichtbruin', 'Donkerbruin', 'Taupe', 'Camel', 'Cognac', 'Tan', 'Chocolade', 'Kastanje', 'Mahonie', 'Walnoot', 'Mokka', 'Koffie', 'Bruin Mix', 'Koffiebruin', 'Roodbruin'] },
  { name: 'Beige',      color: '#d4b896',  members: ['Beige', 'Zand', 'Champagne', 'Nude', 'Licht Beige', 'Crème Beige', 'Zandkleurig', 'Beige met parels', 'Beige-bruin', 'Beige/bruin', 'Lichtbeige', 'Milk tea', 'Zeeschelp'] },
  { name: 'Multicolor', color: 'conic-gradient(red, yellow, lime, cyan, blue, magenta, red)', members: ['Multicolor', 'Multi', 'Regenboog', 'Gekleurd', 'Kleurrijk', 'Gemêleerd', '3-kleurig', 'Color Crazy', 'Colorful', 'Multicolour', 'Taste the Rainbow', 'Wit/kleurrijk', 'Wit/rainbow', 'Zwart/kleurrijk', 'Zwart/rainbow', 'Rood/kleurrijk', 'Roze/kleurrijk', 'Dennengroen/kleurrijk', 'Donkerblauw/kleurrijk', 'Legergroen/kleurrijk', 'Lichtblauw/kleurrijk', 'Sweet Candy', 'Silly Stripes', 'Funky Feather', 'Aurora'] },
  { name: 'Transparant',color: 'linear-gradient(135deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%), linear-gradient(135deg, #ccc 25%, white 25%, white 75%, #ccc 75%)', members: ['Transparant', 'Doorzichtig', 'Clear'] },
  { name: 'Starlight',  color: '#e8e0d4',  members: ['Starlight', 'Sterrenlicht', 'Sterrenlicht Mix', 'Sterrenlicht light', 'Sterrenlicht mix', 'Sterrenlicht/beige', 'Sterrenlicht/lime'] },
  { name: 'Print',      color: 'radial-gradient(circle at 28% 32%, #6b4c1a 14%, transparent 14%), radial-gradient(circle at 68% 28%, #6b4c1a 12%, transparent 12%), radial-gradient(circle at 48% 68%, #6b4c1a 16%, transparent 16%), radial-gradient(circle at 20% 70%, #6b4c1a 10%, transparent 10%), radial-gradient(circle at 80% 65%, #6b4c1a 13%, transparent 13%), #c8903c', members: ['Dancing Dots', 'Dots', 'Flowers', 'Bloemen', 'Pink Flower', 'Sunny Flower', 'Transparent Flower', 'Luminous Butterfly', 'Grey Camo', 'Snake', 'Sneaky Snake', 'Gevlekt'], contains: ['leopard', 'luipaard', 'tijger', 'tiger', 'zebra', 'panter', 'panther', 'snake print', 'slangenprint', 'wit leopard', 'white leopard'] },
];

/** @type {Map<string, number>} */
const colorLookup = new Map();
COLOR_GROUPS.forEach((group, i) => {
  group.members.forEach((member) => colorLookup.set(member.toLowerCase().trim(), i));
});

/**
 * Resolves a CSS color value from a Dutch color name.
 * @param {string} name
 * @returns {string | null}
 */
function resolveColor(name) {
  const normalized = name.toLowerCase().trim();
  let groupIdx = colorLookup.get(normalized);

  if (groupIdx === undefined) {
    for (let i = 0; i < COLOR_GROUPS.length; i++) {
      const contains = COLOR_GROUPS[i].contains || [];
      if (contains.some((c) => c && normalized.includes(c))) {
        groupIdx = i;
        break;
      }
    }
  }

  return groupIdx !== undefined ? COLOR_GROUPS[groupIdx].color : null;
}

class CardColorSwatches extends HTMLElement {
  connectedCallback() {
    const buttons = Array.from(this.querySelectorAll('.card-image-swatch'));
    if (!buttons.length) return;

    const card = this.closest('product-card');

    buttons.forEach((btn) => {
      const colorName = btn.dataset.colorName ?? '';
      const color = resolveColor(colorName);
      const swatch = btn.querySelector('.swatch');
      if (swatch instanceof HTMLElement) {
        if (color) {
          swatch.style.setProperty('--swatch-background', color);
        } else {
          swatch.classList.add('swatch--unavailable');
        }
      }
    });

    const activeBtn = buttons.find((b) => b.getAttribute('aria-pressed') === 'true');
    this._selectedMediaId = activeBtn?.dataset.mediaId ?? null;

    buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();

        const mediaId = btn.dataset.mediaId;
        this._selectedMediaId = mediaId;

        buttons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');

        card?.previewVariant?.(mediaId);
      });

      btn.addEventListener('pointerenter', () => {
        card?.previewVariant?.(btn.dataset.mediaId);
      });

      btn.addEventListener('pointerleave', () => {
        if (this._selectedMediaId) {
          card?.previewVariant?.(this._selectedMediaId);
        }
      });
    });
  }
}

if (!customElements.get('card-color-swatches')) {
  customElements.define('card-color-swatches', CardColorSwatches);
}
